import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import { expandDataProps } from 'utils/helper/common';

import type { Data, StatusLabelSize, StatusLabelType } from 'types';

type Props = {
  label: string,
  type?: StatusLabelType,
  size?: StatusLabelSize,
  colorOverride?: string,
  background?: 'filled' | 'transparent',
  layout?: 'slim' | 'normal' | 'marker',
  className?: string,
  data?: Data
};

const StatusLabel: React.FC<Props> = ({
  label,
  type = 'success',
  size = 'normal',
  colorOverride,
  background = 'filled',
  layout = 'normal',
  className,
  data
}) => {
  const labelClasses = classnames({
    'status-label': true,
    [`status-label--${type}`]: type,
    [`status-label--${size}`]: size,
    [`status-label--${background}`]: background,
    [`status-label--layout-${layout}`]: layout,
    [`${String(className)}`]: className
  });

  if (isNil(label) || label === '') {
    return null;
  }

  let style = {};

  if (colorOverride) {
    style = {
      ...style,
      color: colorOverride,
      borderColor: colorOverride
    };
  }

  return (
    <div
      className={labelClasses}
      style={style}
      {...expandDataProps(data)}
    >
      {label}
    </div>
  );
};

export default StatusLabel;
